import { IPlayer } from '@base/features/player/model/interfaces';
import React from 'react';
import PopoverPlayerAdditionalInfo from '@base/features/playerAdditionalInfo/popoverPlayerAdditionalInfo/popoverPlayerAdditionalInfo';
import Rating from '@base/features/user/components/rating';
import Flag from '@ui-kit/components/flag';

export default function PersonalInfo(props: { player: IPlayer }) {
  const { player } = { ...props };
  return (
    <div className="personal-info">
      <PopoverPlayerAdditionalInfo player={player} key={player.pid} placement="bottom">
        <h2 className="personal-info__name">{player.getName()}</h2>
      </PopoverPlayerAdditionalInfo>
      <div>
        <Flag style={{ marginRight: '.8rem' }} countryCode={player.countryCode} />
        <Rating>{player.getRating()}</Rating>
      </div>
    </div>
  );
}
